<template>
  <div class="report" style="">
    <div class="report-title">赛事报道</div>
    <div class="report-content">
      <div>
        <div class="report-content-item" v-for="(item, index) in tableData" :key="index">
          <div class="report-content-item-left">
            <span class="year">{{item.year}}</span>
            <p class="date">{{item.month}}.{{item.date}}</p>
            <p class="source">{{item.source}}</p>
          </div>
          <div class="report-content-item-right">
            <p class="title" @click="onJump(item.newsUrl)">{{item.title}}</p>
            <p class="content" @click="onJump(item.newsUrl)">{{item.brief}}</p>
          </div>
        </div>
      </div>
      <div class="align-center" style="margin-top: 45px">
        <!-- <button type="button" :disabled="params.pageIndex == 1" class="page-item" @click="onPreve">
          上一页
        </button>
        <button 
          type="button" 
          :class="['page-item', (index + 1) == params.pageIndex ? 'active': '']" 
          v-for="(item, index) in total_page" :key="index" @click="onPage(item)">{{item}}</button>
        <button type="button" :disabled="params.pageIndex == total_page" class="page-item" @click="onNext">
          下一页
        </button> -->
        <pageination 
          :total="count" 
          :current-page="params.pageIndex" 
          :display="params.pageSize" 
          @pagechange="pageCallback"
          v-if="tableData && tableData.length"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import pageination from '@/components/pagination'
export default {
  components: {
    pageination
  },
  data () {
    return {
      params: {
        // match_code: 'shenwanjm',
        pageIndex: 1,
        pageSize: 10
      },
      count: 0,
      total_page: 0,
      tableData: null
    }
  },
  created() {
    this.getTableList(this.params)
  },
  methods: {
    getTableList() {
      axios.post('https://csmarapi.csmar.com/websiteapi/api/SWHY/querynewdata', this.params).then((resp) => {
        if(resp.status == 200) {
          this.tableData = []
          var result = resp.data
          if(result.datas && result.datas.length) {
            result.datas.forEach(item => {
              var val = item.dateTime.split('-')
              item.year = val[0]
              item.month = val[1]
              item.date = val[2]
            })
            this.tableData = result.datas
            this.count = result.total
            this.total_page = this.pageTotal(this.count, 10)

            // 第三方官网返回数据处理
            // result.data.forEach(item => {
            //   item.year = (new Date(item.report_time * 1000)).getFullYear()
            //   item.month = (((new Date(item.report_time * 1000)).getMonth()) + 1) >= 10 ? ((new Date(item.report_time * 1000)).getMonth()) + 1 : '0'+(((new Date(item.report_time * 1000)).getMonth()) + 1)  
            //   item.date = (new Date(item.report_time * 1000)).getDate() >= 10 ? (new Date(item.report_time * 1000)).getDate() : '0'+(new Date(item.report_time * 1000)).getDate()
            // })
            // this.tableData = result.data
            // this.params.page = result.pager.page
            // this.count = result.pager.page
            // this.total_page = result.pager.total_page
            // 第三方官网返回数据处理
          }
        }
      })
    },
    // 计算总页数
    pageTotal(rowCount, pageSize) {
      if (rowCount == null || rowCount == '') {
        return 0;
      } else {
        if (pageSize != 0 && rowCount % pageSize == 0) {
          return parseInt(rowCount / pageSize);
        }
        if (pageSize != 0 && rowCount % pageSize != 0) {
          return parseInt(rowCount / pageSize) + 1;
        }
      }
    },
    // 跳转文章详情
    onJump(url) {
      window.open(url)
    },
    // 分页回调
    pageCallback(page) {
      this.params.pageIndex = page
      this.getTableList()
    },
    onPreve() {
      if (this.params.pageIndex <= 1 ) {
        this.params.pageIndex = 1
      } else {
        --this.params.pageIndex
      }
      this.getTableList()
    },
    onNext() {
      if(this.params.pageIndex >= this.total_page) {
        this.params.pageIndex = this.total_page
      } else {
        ++this.params.pageIndex
      }
      this.getTableList()
    },
    onPage(index) {
      this.params.pageIndex = index
      this.getTableList()
    }
  }
};
</script>

<style lang="less" scoped>
.report{
    width: 1200px;
    margin: 0 auto;
    padding-top: 60px;
    padding-bottom: 49px;
    .align-center {
        text-align: center;
    }
}
.report-title {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 61px;
    background: url('../assets/img/title-bg.png') no-repeat center / 100% 100%;
    font-size: 30px;
    font-weight: bold;
    color: #fff;
}
.report-content {
    padding-top: 38px;
    .report-content-item {
        margin-top: 20px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        .report-content-item-left{
            width: 200px;
            background: #1B2495;
            padding: 28px 10px;
            color: #fff;
            font-size: 18px;
            text-align: center;
            p {
                margin-top: 10px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .year {
                display: -webkit-inline-box;
                display: -ms-inline-flexbox;
                display: inline-flex;
                -webkit-box-pack: center;
                -ms-flex-pack: center;
                justify-content: center;
                -webkit-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                &::before {
                    content: '';
                    display: inline-block;
                    width: 20px;
                    height: 1px;
                    background-color: rgba(247, 247, 247, 0.34);
                    margin-right: 12px;
                }
                &::after {
                    content: '';
                    display: inline-block;
                    width: 20px;
                    height: 1px;
                    background-color: rgba(247, 247, 247, 0.34);
                    margin-left: 12px;
                }
            }
            .date {
                font-size: 26px;
            }
        }
        .report-content-item-right {
            width: 1000px;
            background: #3945A8;
            padding: 30px 38px;
            color: rgba(255, 255, 255, 0.8);
            font-size: 18px;
            line-height: 26px;
            p {
                cursor: pointer;
                &:hover {
                    color: #f11919;
                }
            }
            .title {
                font-size: 22px;
                font-weight: bold;
                margin-bottom: 28px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                color: #fff;
            }
        }
    }
    .page-item{
        font-size: 18px;
        display: inline-block;
        padding: 8px 10px;
        line-height: 20px;
        margin: 0 5px;
        border-radius: 2px;
        cursor: pointer;
        background-color: #3945A8;
        border: none;
        &:disabled {
            cursor: not-allowed;
        }
        &.active {
            background-color: #B38A1F;
            color: #FFFFFF;
        }
    }
}
</style>